import Service from "../../../Service";
import Axios from "../../../Config/API";

export interface IRelatorioControleManutecaoRequest {
    ID_CASO: number;
    DS_CASO: string;
    DS_PRODUTO_COMP?: string;
    DS_CONTATO: string;
    DS_CONTA: string;
    DS_CATEGORIA_ATENDIMENTO_COMP: string;
}

export function ExportRelatorioControleManutencaoService(
    data: IRelatorioControleManutecaoRequest
) {
    return Service(
        Axios.post(
            `/assistenciatecnica/atendimentos/gerarrelatoriocontrolemanutencao`,
            data,
            { responseType: "blob" }
        )
    );
}

export async function ExportarRelatorioControleManutencaoDiaService(
    comSistema: boolean,
    DT_INICIO: string,
    DT_FIM: string
) {
    return Service(
        Axios.get<Blob>(
            `/assistenciatecnica/atendimentos/gerarvariosrelatoriocontrolemanutencaododia?comSistema=${comSistema}&DT_INICIO=${DT_INICIO}&DT_FIM=${DT_FIM}`,
            { responseType: "blob" }
        )
    );
}

export async function ExportarRelatorioPDFControleManutencaoDiaService(
    comSistema: boolean,
    DT_INICIO: string,
    DT_FIM: string,
    ID_USUARIO: number
) {
    return Service(
        Axios.get<Blob>(
            `/assistenciatecnica/atendimentos/gerarvariosrelatoriocontrolemanutencaododiapdf?comSistema=${comSistema}&DT_INICIO=${DT_INICIO}&DT_FIM=${DT_FIM}&ID_USUARIO=${ID_USUARIO}`,
            { responseType: "blob" }
        )
    );
}

export function ExportarRelatorioControleManutencaoSemSistemaService(
    data: IRelatorioControleManutecaoRequest,
    comSistema: boolean
) {
    return Service(
        Axios.post<Blob>(
            `/assistenciatecnica/atendimentos/gerarrelatoriocontrolemanutencao?comSistema=${comSistema}`,
            data,
            { responseType: "blob" }
        )
    );
}
